// extracted by mini-css-extract-plugin
export default {"test-now":"test-now-inOPU"};